import { useAuth } from "../App";
import AppGreetingSettings from "./AppSettings";
import ServerStatus from "./ServerStatus";
import VaultPinSettings from "../components/vault/VaultPinSettings";
import TimeEditLockSettings from "./TimeEditLockSettings";
import AppDesignSettings from "./AppDesignSettings";
import NinaMenuSettings from "./NinaMenuSettings";

export default function AppSettingsPage() {
  const { user } = useAuth();

  if (user?.role !== "admin") {
    return (
      <div className="text-center py-12" style={{ color: "var(--tga-text-muted)" }}>
        Nur für Administratoren zugänglich.
      </div>
    );
  }

  return (
    <div className="space-y-6 max-w-2xl" data-testid="app-settings-page">
      <div>
        <h1 className="text-lg font-bold" style={{ color: "var(--tga-text-primary)" }}>App-Einstellungen</h1>
        <p className="text-xs" style={{ color: "var(--tga-text-muted)" }}>Globale Konfiguration & Server-Diagnose</p>
      </div>
      <NinaMenuSettings />
      <TimeEditLockSettings />
      <AppDesignSettings />
      <ServerStatus />
      <VaultPinSettings />
      <AppGreetingSettings user={user} />
    </div>
  );
}
